import { Injectable } from '@angular/core';

export type ConditionPayload = {
  condition: unknown | null;
  details?: unknown[];
  taxonomy?: unknown[];
};

@Injectable({ providedIn: 'root' })
export class EntryPayloadCacheService {
  private readonly byKey = new Map<string, ConditionPayload>();

  private key(module: string, slug: string): string {
    return `${module}::${slug}`;
  }

  get(module: string, slug: string): ConditionPayload | null {
    return this.byKey.get(this.key(module, slug)) ?? null;
  }

  set(module: string, slug: string, payload: ConditionPayload): void {
    this.byKey.set(this.key(module, slug), payload);
  }

  clear(): void {
    this.byKey.clear();
  }
}
